import { render, staticRenderFns } from "./PhysicalEvaluation.vue?vue&type=template&id=2ebdb680"
import script from "./PhysicalEvaluation.vue?vue&type=script&lang=js"
export * from "./PhysicalEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports